import { Badge } from '@bambi/component-library/src/components/Badge/Badge';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import truncate from 'lodash-es/truncate';

import type { PayerOrganizationRead } from 'src/common/external/bambi-api/bambiApi';
import type { TripListPayerOrgRead } from 'src/common/external/bambi-api/tripsApi';

export function PayerDisplayCell({
  payer,
}: {
  payer: TripListPayerOrgRead | PayerOrganizationRead;
}) {
  const displayName = payer.display_name;
  const isActive = payer.is_active;

  return (
    <div className="flex flex-row items-center gap-1">
      {displayName
        ? truncate(displayName, {
            length: 30,
            omission: '...',
          })
        : ''}
      {!isActive ? (
        <SimpleTooltip
          trigger={
            <div>
              <Badge label="Payer Inactive" color="red" />
            </div>
          }
          content="This trip's payer is inactive, it will not appear on the dispatch screen"
        />
      ) : null}
    </div>
  );
}
